import posthog from 'posthog-js';
/**
 * Initialize PostHog for browser-side product analytics.
 * Call once at app root before rendering.
 */
export function initPostHog(config) {
    posthog.init(config.apiKey, {
        api_host: config.host ?? 'https://us.i.posthog.com',
        capture_pageview: true,
        capture_pageleave: true,
        session_recording: {
            maskAllInputs: true,
        },
        bootstrap: {},
    });
}
/**
 * Identify the current user in PostHog.
 * Call after successful login with userId, tenantId, and any profile properties.
 */
export function identify(userId, tenantId, properties) {
    posthog.identify(userId, { tenantId, ...properties });
    posthog.group('tenant', tenantId, { tenantId });
}
/**
 * Track a typed event in PostHog.
 */
export function track(event, properties) {
    posthog.capture(event, properties);
}
/**
 * Reset PostHog identity (call on logout).
 */
export function resetPostHog() {
    posthog.reset();
}
// ---------------------------------------------------------------------------
// Phase F — typed event helpers (copilot, search, description generation)
// All functions are fire-and-forget; they never throw.
// ---------------------------------------------------------------------------
export function trackCopilotQuery(props) {
    track('copilot_query_sent', props);
}
export function trackCopilotAction(props) {
    track('copilot_action_confirmed', props);
}
export function trackCopilotFeedback(props) {
    track('copilot_feedback_given', props);
}
export function trackCopilotSessionEnd(props) {
    track('copilot_session_ended', props);
}
export function trackSearch(props) {
    track('search_performed', props);
}
export function trackSearchClick(props) {
    track('search_result_clicked', props);
}
export function trackDescriptionGenerated(props) {
    track('description_generated', props);
}
export function trackDescriptionSaved(props) {
    track('description_saved', props);
}
// ---------------------------------------------------------------------------
// Phase G — Website builder (Sitio)
// ---------------------------------------------------------------------------
export function trackSitePagePublished(props) {
    track('site_page_published', props);
}
export function trackSiteFormSubmitted(props) {
    track('site_form_submitted', props);
}
export function trackSiteCustomDomainConnected(props) {
    track('site_custom_domain_connected', props);
}
export function trackSiteThemeChanged(props) {
    track('site_theme_changed', props);
}
export function trackSiteBlockAdded(props) {
    track('site_block_added', props);
}
// ---------------------------------------------------------------------------
// Phase G — Appraisals (Tasaciones)
// ---------------------------------------------------------------------------
export function trackAppraisalCreated(props) {
    track('appraisal_created', props);
}
export function trackAppraisalCompSearch(props) {
    track('appraisal_comp_searched', props);
}
export function trackAppraisalAiNarrative(props) {
    track('appraisal_ai_narrative_generated', props);
}
export function trackAppraisalPdfDownloaded(props) {
    track('appraisal_pdf_downloaded', props);
}
// ---------------------------------------------------------------------------
// Phase G — Report adoption
// ---------------------------------------------------------------------------
export function trackReportViewed(props) {
    track('report_viewed', props);
}
export function trackReportExported(props) {
    track('report_exported', props);
}
export function trackReportDigestScheduled(props) {
    track('report_digest_scheduled', props);
}
// ---------------------------------------------------------------------------
// Phase G — Billing / subscription
// ---------------------------------------------------------------------------
export function trackBillingCheckoutStarted(props) {
    track('billing_checkout_started', props);
}
export function trackPlanChanged(props) {
    track('plan_changed', props);
}
export function trackTrialConverted(props) {
    track('trial_converted', props);
}
// Re-export PostHog React hook for feature flags
export { useFeatureFlagEnabled as useFeatureFlag } from 'posthog-js/react';
//# sourceMappingURL=posthog.js.map